<template>
  <div class="artisan-detail-page">
    <section class="artisan-profile">
      <div class="site-shell">
        <button class="back-link" type="button" @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回匠人名录</button>

        <div class="artisan-profile__grid">
          <div class="artisan-profile__portrait" :class="{ 'is-loading': loading, 'is-error': avatarError }">
            <img v-if="master.avatar && !avatarError && !loading" :src="getFullImageUrl(master.avatar)" :alt="master.masterName" @error="handleImageError">
            <div v-else class="image-placeholder">
              <i :class="loading ? 'el-icon-loading' : 'el-icon-user'"></i>
            </div>
          </div>

          <div class="artisan-profile__intro">
            <p class="eyebrow">ARTISAN PROFILE</p>
            <h1>{{ master.masterName || '匠人档案' }}</h1>
            <p class="artisan-profile__craft">{{ master.craft || '玉雕技艺' }}</p>
            <div class="artisan-profile__rule"></div>
            <div class="artisan-profile__lead" v-html="master.profile || '专注玉雕技艺，以作品记录手艺。'"></div>
            <div v-if="!isOnline" class="network-status"><i class="el-icon-warning-outline"></i> 当前离线，部分图片可能无法显示</div>
          </div>
        </div>
      </div>
    </section>

    <section class="artisan-story">
      <div class="site-shell artisan-story__grid">
        <aside>
          <p class="eyebrow">CRAFT &amp; HONOR</p>
          <h2>手艺与荣誉</h2>
          <p>从长期实践中形成个人语言，也让每次落刀都有分寸。</p>
        </aside>
        <div class="artisan-story__content">
          <div class="story-block">
            <div>
              <h3>匠人简介</h3>
              <div class="rich-text" v-html="master.profile || '暂无简介'"></div>
            </div>
          </div>
          <div class="story-block">
            <div>
              <h3>荣誉成就</h3>
              <div class="rich-text" v-html="master.honors || '暂无荣誉资料'"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getMasterDetail } from '@/api/masters'

export default {
  name: 'MasterDetail',
  data() {
    return {
      master: { id: null, avatar: '', masterName: '', craft: '', honors: '', profile: '' },
      loading: true,
      avatarError: false,
      isOnline: navigator.onLine
    }
  },
  created() {
    this.fetchMasterDetail()
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },
  methods: {
    async fetchMasterDetail() {
      const id = this.$route.params.id
      if (!id) {
        this.$message.error('无效的匠人ID')
        this.$router.go(-1)
        return
      }
      try {
        this.loading = true
        const response = await getMasterDetail(id)
        if (response.code === 200) {
          this.master = response.data || {}
          document.title = this.master.masterName + ' - 玉雕匠人'
          window.setTimeout(() => { this.loading = false }, 200)
        } else {
          this.$message.error(response.msg || '获取匠人详情失败')
          this.$router.go(-1)
        }
      } catch (error) {
        console.error('获取匠人详情出错:', error)
        this.$message.error('获取匠人详情失败')
        this.loading = false
      }
    },
    getFullImageUrl(path) {
      if (!path) return ''
      return path.startsWith('http') ? path : process.env.VUE_APP_BASE_API + path
    },
    handleImageError() {
      this.avatarError = true
    },
    updateOnlineStatus() {
      this.isOnline = navigator.onLine
      if (this.isOnline) this.avatarError = false
    }
  }
}
</script>
